<template>
  <div
    class="payouts-to-card-table-item"
    @click="$emit('click', payoutsRegistry.id)"
  >
    <div class="transaction-table-item">
      <div class="transaction-table-item__short-info">
        <div class="transaction-table-item__col transaction-table-item__date">
          <div class="transaction-table-item__date-main">
            {{ payoutsRegistry.dateTime.date }}
          </div>
          <div class="transaction-table-item__date-time">
            {{ payoutsRegistry.dateTime.time }}
          </div>
        </div>
        <div class="transaction-table-item__col transaction-table-item__name">
          {{ payoutsRegistry.registryName }}
        </div>
        <div
          class="transaction-table-item__col transaction-table-item__p-count"
        >
          {{ payoutsRegistry.totalCount }}
        </div>
        <div class="transaction-table-item__col transaction-table-item__p-sum">
          {{ payoutsRegistry.totalSum }}
        </div>
        <div class="transaction-table-item__col transaction-table-item__status">
          <transaction-status
            :status-id="payoutsRegistry.status"
          ></transaction-status>
        </div>
        <transactions-table-actions-button
          :actions="itemActions"
          ref="transactionActionsMenu"
          @actionFired="handleActionFired"
        >
        </transactions-table-actions-button>
      </div>
    </div>
    <payouts-registry-edit-popup ref="editPopup"></payouts-registry-edit-popup>
    <success-notification
      ref="editRegistryNotification"
      :text="$t('payouts.by-registry.registry.notifications.updated-success')"
    ></success-notification>
    <success-notification
      ref="payoutsRegistryProcessingNotification"
      :text="
        $t('payouts.by-registry.created.notifications.registry-in-progress')
      "
    ></success-notification>
    <payouts-registry-delete-popup
      ref="payoutsRegistryDeletePopup"
    ></payouts-registry-delete-popup>
  </div>
</template>

<script>
import {
  $on,
  $off,
  $once,
  $emit,
} from '../../../../../../utils/gogocodeTransfer'
import TransactionStatus from '@vue-app/components/transaction/TransactionStatus.vue'
import { CompaniesApi } from '@js-app/office/api/companies-api'
import { RouteHelper } from '@js-app/services/helpers/routes/routes-helper'
import { mapState } from 'vuex'
import Loader from '@vue-app/components/base/Loader.vue'
import PayoutsRegistry from '@js-app/entities/payouts/PayoutsRegistry'
import TransactionsTableActionsButton from '@vue-app/components/company/transactions/table/TransactionsTableActionsButton.vue'
import PayoutsRegistryEditPopup from '@vue-app/components/company/payouts/by-registry/popup/PayoutsRegistryEditPopup.vue'
import SuccessNotification from '@vue-app/components/base/popup/notification/SuccessNotification.vue'
import PayoutsRegistryDeletePopup from '@vue-app/components/company/payouts/by-registry/popup/PayoutsRegistryDeletePopup.vue'

export default {
  name: 'PayoutsRegistryTableItem',
  components: {
    PayoutsRegistryDeletePopup,
    SuccessNotification,
    PayoutsRegistryEditPopup,
    TransactionsTableActionsButton,
    Loader,
    TransactionStatus,
  },
  props: {
    payoutsRegistry: {
      type: PayoutsRegistry,
    },
  },
  data: () => ({
    transactionReceiptBlob: null,
  }),
  computed: {
    ...mapState(['selectedCompany']),
    itemActions() {
      let _actions = []

      if (this.payoutsRegistry.status === 0) {
        _actions.push({
          id: 'delete',
          title: this.$t('payouts.by-registry.registry.actions.delete'),
          handler: this.deleteRegistry,
        })
        _actions.push({
          id: 'edit',
          title: this.$t('payouts.by-registry.registry.actions.edit-name'),
          handler: this.handleEditRegistry,
        })
        _actions.push({
          id: 'process',
          title: this.$t(
            'payouts.by-registry.registry.actions.process-registry'
          ),
          handler: this.handleProcessRegistry,
        })
      }

      return _actions
    },
  },
  methods: {
    async handleActionFired(action) {
      try {
        await action.handler()
      } catch (e) {
        console.error(e)
      }

      try {
        this.$refs.transactionActionsMenu.actionFinished(action.id)
      } catch (e) {}
    },
    async handleEditRegistry() {
      let editResponse = await this.$refs.editPopup.open(
        this.payoutsRegistry.payoutsRegistryData
      )

      if (!editResponse) {
        return
      }

      $emit(this, 'registryItemUpdated', editResponse)
      this.payoutsRegistry.payoutsRegistryData.name = editResponse.name

      await CompaniesApi.updateRegistry(
        this.selectedCompany,
        editResponse.id,
        editResponse
      )

      this.$refs.editRegistryNotification.show()
    },
    async handleProcessRegistry() {
      this.isRegistryProcessing = true
      try {
        this.$refs.payoutsRegistryProcessingNotification.show()
        this.payoutsRegistry.payoutsRegistryData.status = 'processing'

        await CompaniesApi.processPayoutsRegistry(
          this.selectedCompany,
          this.payoutsRegistry.id
        )
      } finally {
        this.isRegistryProcessing = false
      }
    },
    async deleteRegistry() {
      if (
        !(await this.$refs.payoutsRegistryDeletePopup.open(
          this.payoutsRegistry.registryName
        ))
      ) {
        return
      }

      try {
        await CompaniesApi.deletePayoutsRegistry(
          this.selectedCompany,
          this.payoutsRegistry.id
        )
        $emit(this, 'deleted', this.payoutsRegistry)
      } catch (e) {
        console.error(e)
      }
    },
    toPayoutToCardDetails() {
      this.$router.push(
        RouteHelper.getRoute('payout-to-card-view', {
          companyId: this.selectedCompany,
          payoutId: this.transaction.operationId,
        })
      )
    },
  },
  emits: ['click', 'registryItemUpdated', 'deleted'],
}
</script>

<style lang="scss" scoped>
.payouts-to-card-table-item {
  .transaction-table-item {
    &__date {
      padding: 0;
    }

    &__short-info {
      box-shadow: 0px 2px 14px transparent;
      transition: box-shadow 0.2s linear;

      &:hover {
        cursor: pointer;
        box-shadow: 0px 2px 14px rgba(208, 217, 231, 0.4);
      }
    }

    &__name {
      word-break: break-all;
      font-weight: 500;
      font-size: 14px;
      line-height: 18px;
      color: #1a1f29;
      opacity: 0.7;
    }

    &__amount {
      font-weight: 600;
      font-size: 14px;
      line-height: 18px;
      color: #1a1f29;
      opacity: 0.7;
      justify-content: flex-end;
    }

    &__p-count {
      justify-content: flex-end;
    }

    &__p-sum {
      justify-content: flex-end;
    }

    &__status {
      align-self: center;
      display: flex;
      align-items: center;
      justify-content: center;
      padding-left: 20px;
      padding-right: 20px;

      &-item {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 105px;
        max-width: 100%;
        height: 28px;
        border-radius: 6px;
        font-weight: 500;
        font-size: 12px;
        line-height: 28px;

        &--paid {
          background: rgba(39, 204, 36, 0.2);
          color: #44d941;
        }
      }
    }
  }
}
</style>
